import React from "react";
import Skeleton from "react-loading-skeleton";
import { Row, Col, Card } from "antd";

const BASE = "#eae7f2";

const Sk = (props) => <Skeleton baseColor={BASE} {...props} />;

export function GoalsListSkeleton({ rows = 6 }) {
  return (
    <div style={{ marginTop: 8 }}>
      {[...Array(rows)].map((_, i) => (
        <div
          key={i}
          style={{
            marginBottom: 12,
            borderBottom: "1px solid rgba(38, 38, 38, 0.1)",
            paddingBottom: 12,
          }}
        >
          <Sk width="55%" height={16} />
          <div style={{ marginTop: 8 }}>
            <Sk width="35%" height={20} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function FlorencePageSkeleton() {
  return (
    <div className="florence-workspace" style={{ minHeight: "calc(100vh - 200px)" }}>
      <Row gutter={[14, 10]} className="florence-main-grid" align="stretch">
        <Col xs={24} xl={15}>
          <Card bordered={false} className="buyers-list florence-list-card">
            <Sk height={36} width={220} style={{ marginBottom: 16 }} />
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: 12,
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid rgba(38, 38, 38, 0.08)",
                }}
              >
                <Sk circle width={40} height={40} />
                <div style={{ flex: 1 }}>
                  <Sk width="72%" height={16} />
                  <Sk width="48%" height={14} style={{ marginTop: 6 }} />
                </div>
              </div>
            ))}
          </Card>
          <Card bordered={false} style={{ marginTop: 14 }}>
            <Sk height={20} width="42%" />
            <Sk count={3} style={{ marginTop: 14 }} />
          </Card>
        </Col>
        <Col xs={24} xl={9}>
          <Card bordered={false}>
            <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
              <Sk circle width={56} height={56} />
              <div style={{ flex: 1 }}>
                <Sk width="65%" height={22} />
                <Sk width="45%" height={14} style={{ marginTop: 8 }} />
              </div>
            </div>
            {[...Array(6)].map((_, i) => (
              <div key={i} style={{ marginBottom: 14 }}>
                <Sk width="32%" height={12} />
                <Sk width="85%" height={16} style={{ marginTop: 6 }} />
              </div>
            ))}
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export function FormStepsSkeleton({ height = 300 }) {
  return (
    <Card bordered={false} style={{ height, padding: 24 }}>
      {[...Array(5)].map((_, i) => (
        <div key={i} style={{ marginBottom: 24 }}>
          <Sk width="28%" height={14} style={{ marginBottom: 8 }} />
          <Sk height={32} />
        </div>
      ))}
    </Card>
  );
}

export function KanbanSkeleton({ columns = 5, cardsPerColumn = 3 }) {
  return (
    <div style={{ display: "flex", gap: 16, overflow: "hidden", paddingTop: 8 }}>
      {[...Array(columns)].map((_, col) => (
        <div key={col} style={{ flex: 1, minWidth: 160 }}>
          <Sk height={18} width="75%" style={{ marginBottom: 12 }} />
          {[...Array(cardsPerColumn)].map((_, row) => (
            <Card key={row} bordered={false} style={{ marginBottom: 8 }} bodyStyle={{ padding: 12 }}>
              <Sk width="92%" height={14} />
              <Sk width="58%" height={12} style={{ marginTop: 8 }} />
            </Card>
          ))}
        </div>
      ))}
    </div>
  );
}

export function ListItemsSkeleton({ rows = 5 }) {
  return (
    <div>
      {[...Array(rows)].map((_, i) => (
        <Card
          key={i}
          bordered={false}
          style={{ marginBottom: 12 }}
          bodyStyle={{ padding: "14px 16px" }}
        >
          <Sk width="40%" height={16} />
          <Sk count={2} style={{ marginTop: 10 }} />
        </Card>
      ))}
    </div>
  );
}

export function InvestorDetailSkeleton() {
  return (
    <Card bordered={false} className="basic-detail">
      <div style={{ display: "flex", gap: 16, marginBottom: 20, alignItems: "center" }}>
        <Sk circle width={64} height={64} />
        <Sk width={240} height={28} />
      </div>
      <Sk count={3} style={{ marginBottom: 24 }} />
      <Row gutter={[16, 16]}>
        {[...Array(8)].map((_, i) => (
          <Col key={i} xs={24} md={12} lg={8}>
            <Sk width="35%" height={12} />
            <Sk width="80%" height={16} style={{ marginTop: 6 }} />
          </Col>
        ))}
      </Row>
    </Card>
  );
}

export function AnalyticsCardsSkeleton({ count = 8 }) {
  return (
    <Row gutter={[12, 12]}>
      {[...Array(count)].map((_, i) => (
        <Col key={i} xs={24} sm={12} lg={6}>
          <Card className="analytics-card">
            <Sk width="70%" height={14} />
            <Sk width="50%" height={32} style={{ marginTop: 12 }} />
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export function UserListSkeleton({ rows = 8 }) {
  return (
    <div className="users-list-items">
      {[...Array(rows)].map((_, i) => (
        <div key={i} style={{ padding: "10px 0", borderBottom: "1px solid rgba(38, 38, 38, 0.06)" }}>
          <Sk width="85%" height={16} />
          <Sk width="60%" height={12} style={{ marginTop: 6 }} />
        </div>
      ))}
    </div>
  );
}

export function SubscriptionCardSkeleton() {
  return (
    <Card className="card-box">
      <Sk width={220} height={28} />
      <Sk width={140} height={18} style={{ marginTop: 12 }} />
      <Sk width={160} height={40} style={{ marginTop: 24, borderRadius: 8 }} />
      <Sk count={2} style={{ marginTop: 20 }} />
    </Card>
  );
}

export function DocumentGridSkeleton({ count = 8 }) {
  return (
    <Row className="documents-grid" gutter={[16, 16]}>
      {[...Array(count)].map((_, i) => (
        <Col key={i} xs={24} md={8} lg={6} xl={4}>
          <Sk height={140} borderRadius={8} />
          <Sk width="70%" height={14} style={{ marginTop: 8 }} />
        </Col>
      ))}
    </Row>
  );
}

export function TableSkeleton({ rows = 10 }) {
  return (
    <div>
      <Sk height={44} style={{ marginBottom: 8 }} />
      {[...Array(rows)].map((_, i) => (
        <Sk key={i} height={52} style={{ marginBottom: 4 }} />
      ))}
    </div>
  );
}

export function LayoutPageSkeleton() {
  return (
    <div style={{ padding: "8px 0" }}>
      <Sk width={200} height={28} style={{ marginBottom: 24 }} />
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card bordered={false}>
            <Sk count={4} />
          </Card>
        </Col>
        <Col span={13}>
          <Card bordered={false} style={{ minHeight: 280 }}>
            <Sk count={5} />
          </Card>
        </Col>
        <Col span={11}>
          <Card bordered={false} style={{ minHeight: 280 }}>
            <Sk count={4} />
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export function ProfileFormSkeleton() {
  return (
    <Row gutter={[16, 16]}>
      {[...Array(3)].map((_, i) => (
        <Col key={i} xs={24} md={12} lg={8}>
          <Sk width="28%" height={12} style={{ marginBottom: 6 }} />
          <Sk height={40} style={{ borderRadius: 8 }} />
        </Col>
      ))}
    </Row>
  );
}

export function PremiumLayoutSkeleton() {
  return (
    <Card bordered={false} style={{ maxWidth: 480, margin: "0 auto", padding: 8 }}>
      <Sk width="60%" height={24} style={{ marginBottom: 16 }} />
      <Sk count={3} />
      <Sk width={140} height={40} style={{ marginTop: 24, borderRadius: 8 }} />
    </Card>
  );
}

export function PageSkeleton({ variant = "layout", ...props }) {
  switch (variant) {
    case "florence":
      return <FlorencePageSkeleton {...props} />;
    case "goals":
      return <GoalsListSkeleton {...props} />;
    case "form":
      return <FormStepsSkeleton {...props} />;
    case "kanban":
      return <KanbanSkeleton {...props} />;
    case "list":
      return <ListItemsSkeleton {...props} />;
    case "investor-detail":
      return <InvestorDetailSkeleton {...props} />;
    case "analytics":
      return <AnalyticsCardsSkeleton {...props} />;
    case "user-list":
      return <UserListSkeleton {...props} />;
    case "subscription":
      return <SubscriptionCardSkeleton {...props} />;
    case "documents":
      return <DocumentGridSkeleton {...props} />;
    case "table":
      return <TableSkeleton {...props} />;
    case "profile":
      return <ProfileFormSkeleton {...props} />;
    case "premium":
      return <PremiumLayoutSkeleton {...props} />;
    case "layout":
    default:
      return <LayoutPageSkeleton {...props} />;
  }
}

export default PageSkeleton;
